// Highlight effects for text-with-media component
// Simplified approach based on bolean Animation Framework
// Only creates animations when elements intersect, no complex state management

// SVG creation functions with dynamic sizing
function createCircleSvg(pencilStyle = false, elementWidth = 200, elementHeight = 60) {
  const filterId = `pencil-filter-${Math.random().toString(36).substr(2, 9)}`;
  
  // Use the original Stretch approach with fixed viewBox and hand-drawn path
  return `
    <svg part="shape circle-shape" preserveAspectRatio="none" viewBox="0 0 239 112" fill="none" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;">
      ${pencilStyle ? createPencilFilter(filterId) : ""}
      <path part="path" ${pencilStyle && `filter="url(#${filterId})"`} stroke="currentColor" stroke-linecap="round" stroke-width="${pencilStyle ? 3 : 2}" vector-effect="non-scaling-stroke" d="M209.793 7.563c-3.761-.066-7.336-.809-11.059-1.198-10.522-1.1-21.334-1.187-31.894-1.589-17.861-.68-35.657-.632-53.487.755-17.875 1.39-36.15 3.045-53.724 6.72-17.695 3.699-32.947 11.442-45.652 24.193C8.604 41.836 3.724 46.924 1.712 54.49c-1.766 6.646-.057 13.37 3.04 19.376 7.31 14.176 24.289 21.161 38.576 25.938 31.322 10.471 65.275 12.613 98.066 10.417 18.208-1.22 36.408-3.315 54.221-7.344 9.566-2.164 19.614-4.969 28.225-9.844 9.515-5.388 15.133-14.411 14.02-25.392-1.145-11.3-8.044-20.744-15.828-28.594-15.36-15.49-37.406-23.105-58.153-28.569C140.302 4.271 116.23 1 91.863 1" style="stroke-dasharray: 10000; stroke-dashoffset: 10000;"/>
    </svg>
  `;
}

function createUnderlineSvg(pencilStyle = false, elementWidth = 200, elementHeight = 20) {
  const filterId = `pencil-filter-${Math.random().toString(36).substr(2, 9)}`;
  
  // Use the original Stretch approach with fixed viewBox
  return `
    <svg part="shape underline-shape" preserveAspectRatio="none" viewBox="0 0 215 14" fill="none" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;">
      ${pencilStyle ? createPencilFilter(filterId) : ""}
      <path part="path" ${pencilStyle && `filter="url(#${filterId})"`} stroke="currentColor" stroke-linecap="round" stroke-width="${pencilStyle ? 3 : 2}" vector-effect="non-scaling-stroke" d="M1 1c20.54 2.356 41.237 2.634 61.957 2.703 25.31.085 50.625.028 75.928-.467 19.199-.376 38.386-1.092 57.584-1.503 5.836-.125 11.686-.278 17.526-.278.17 0-4.327.618-4.547.644-29.274 3.52-58.822 5.58-88.31 7.542-26.569 1.768-53.22 2.055-79.861 2.552-2.122.039-4.269.06-6.388.176-2.502.137 4.997.4 7.505.443 46.458.782 92.838-1.125 139.285-1.125" style="stroke-dasharray: 10000; stroke-dashoffset: 10000;"/>
    </svg>
  `;
}

function createPencilFilter(filterId) {
  return `
    <defs>
      <filter x="-5%" y="-5%" width="110%" height="110%" filterUnits="objectBoundingBox" id="${filterId}">
        <feTurbulence type="fractalNoise" baseFrequency="0.5" numOctaves="5" stitchTiles="stitch" result="t1"></feTurbulence>
        <feColorMatrix type="matrix" values="0 0 0 0 0, 0 0 0 0 0, 0 0 0 0 0, 0 0 0 -1.5 1.5" result="t2"></feColorMatrix>
        <feComposite operator="in" in2="t2" in="SourceGraphic" result="SourceTextured"></feComposite>
        <feTurbulence type="fractalNoise" baseFrequency="1.2" numOctaves="3" seed="1" result="f1"></feTurbulence>
        <feDisplacementMap xChannelSelector="R" yChannelSelector="G" scale="2.5" in="SourceTextured" in2="f1" result="f4"></feDisplacementMap>
      </filter>
    </defs>
  `;
}

// Get lines directly from split-lines elements (like original Stretch theme)
function getSplitLines(element) {
  return Array.from(element.querySelectorAll("split-lines")).flatMap((item) => item.lines);
}

// Create highlight animations
function createHighlightAnimations(element, effect, lines) {
  console.log('Creating animations for effect:', effect, 'lines:', lines.length);
  
  switch (effect) {
    case "marker":
    case "tilted-marker":
      createMarkerAnimations(lines, effect);
      break;
    case "circle":
    case "circle-pencil":
    case "underline":
    case "underline-pencil":
      createSvgAnimations(lines, effect);
      break;
  }
}

// Marker animations (marker, tilted-marker)
function createMarkerAnimations(lines, effect) {
  lines.forEach((line, index) => {
    line.style.zIndex = lines.length - index;
    line.setAttribute("data-content", line.textContent);
    line.style.willChange = 'clip-path, transform';
    
    const startClipPath = document.dir === "ltr" ? "inset(0 0 0 100%)" : "inset(0 100% 0 0)";
    const endClipPath = "inset(0 0 0 0)";
    
    // Before pseudo-element animation
    line.animate(
      { clipPath: [startClipPath, endClipPath] },
      {
        fill: "forwards",
        duration: 700,
        delay: 350 * index,
        easing: "cubic-bezier(0.85, 0, 0.15, 1)",
        pseudoElement: "::before"
      }
    );
    
    // After pseudo-element animation
    line.animate(
      { clipPath: [startClipPath, endClipPath] },
      {
        fill: "forwards",
        duration: 700,
        delay: 350 * index,
        easing: "cubic-bezier(0.85, 0, 0.15, 1)",
        pseudoElement: "::after"
      }
    );
    
    // Tilted marker transform animation
    if (effect === "tilted-marker") {
      line.animate(
        { transform: ["rotate(0)", "rotate(-4deg)"] },
        {
          fill: "forwards",
          duration: 700,
          delay: 350 * index,
          easing: "cubic-bezier(0.85, 0, 0.15, 1)"
        }
      );
    }
    
    // Clear willChange after animation
    setTimeout(() => {
      line.style.willChange = 'auto';
    }, 700 + (350 * index));
  });
}

// SVG animations (circle, underline with optional pencil style)
function createSvgAnimations(lines, effect) {
  console.log('Creating SVG animations for effect:', effect, 'lines:', lines.length);
  const pencilStyle = effect.includes("pencil");
  
  lines.forEach((line, index) => {
    console.log('Processing line:', line.textContent, 'index:', index);
    
    // Remove existing SVG
    line.querySelector("svg")?.remove();
    
    // Get actual element dimensions
    const rect = line.getBoundingClientRect();
    const elementWidth = Math.max(rect.width, 100); // Minimum width of 100px
    const elementHeight = Math.max(rect.height, 20); // Minimum height of 20px
    
    console.log('Element dimensions:', elementWidth, 'x', elementHeight);
    
    // Create new SVG with dynamic sizing
    const svgHtml = effect.includes("circle") 
      ? createCircleSvg(pencilStyle, elementWidth, elementHeight) 
      : createUnderlineSvg(pencilStyle, elementWidth, elementHeight);
    console.log('Inserting SVG HTML:', svgHtml);
    line.insertAdjacentHTML("beforeend", svgHtml);
    
    const svg = line.querySelector("svg");
    const path = line.querySelector("path");
    
    console.log('SVG found:', !!svg, 'Path found:', !!path);
    
    if (svg && path) {
      console.log('Setting up SVG animation for line:', line.textContent);
      
      // Use original Stretch scale factor approach
      const scaleFactor = Math.max(svg.getBoundingClientRect().width, svg.getBoundingClientRect().height) / Math.max(svg.getBBox().width, svg.getBBox().height);
      const adjustedPathLength = path.getTotalLength() * scaleFactor;
      console.log('Stroke length:', path.getTotalLength(), 'Scale factor:', scaleFactor, 'Adjusted length:', adjustedPathLength);
      
      path.setAttribute("stroke-dasharray", adjustedPathLength);
      path.setAttribute("stroke-dashoffset", adjustedPathLength);
      
      // Use CSS transition with different bezier curves to test
      console.log('Testing CSS transition with different bezier curves');
      
      // Use original Stretch bezier curve
      path.style.setProperty('transition', `stroke-dashoffset 2000ms cubic-bezier(0.83, 0.01, 0.57, 1) ${500 * index}ms`, 'important');
      
      // Trigger animation after a small delay to ensure styles are applied
      setTimeout(() => {
        console.log('About to set strokeDashoffset to 0');
        path.style.strokeDashoffset = '0';
        console.log('Animation triggered for line:', line.textContent, 'strokeDashoffset set to 0');
      }, 50);
      
      console.log('SVG animation started for line:', line.textContent);
    } else {
      console.log('SVG or stroke element not found for line:', line.textContent);
    }
  });
}

// Initialize highlight effects when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const effect = element.getAttribute('effect');
        
        if (effect && effect !== 'italic') {
          console.log('Element intersecting, triggering effect:', effect);
          triggerHighlightEffect(element, effect);
          observer.unobserve(element); // Stop observing after animation
        }
      }
    });
  }, { 
    threshold: 0.1,
    rootMargin: "0% 0% -15% 0%" 
  });
  
  // Observe all highlighted-heading elements
  document.querySelectorAll('highlighted-heading[effect]').forEach(element => {
    observer.observe(element);
  });
});

// Trigger highlight effect when element intersects
function triggerHighlightEffect(element, effect) {
  // Get lines directly (like original Stretch theme)
  const lines = getSplitLines(element);
  console.log('Found lines:', lines.length);
  
  // Debug: Check if lines are empty and try waiting if needed
  if (lines.length === 0) {
    console.log('No lines found, waiting for split-lines to be ready...');
    waitForSplitLines(element, () => {
      const lines = getSplitLines(element);
      console.log('After waiting, found lines:', lines.length);
      createHighlightAnimations(element, effect, lines);
    });
  } else {
    // Create animations based on effect type
    createHighlightAnimations(element, effect, lines);
  }
}

// Wait for split-lines to be ready (fallback)
function waitForSplitLines(element, callback) {
  const splitLinesElement = element.querySelector('split-lines');
  
  if (!splitLinesElement) {
    console.log('No split-lines element found');
    callback();
    return;
  }
  
  // Check if already split
  if (splitLinesElement.classList.contains('is-split')) {
    console.log('Split-lines already ready');
    callback();
    return;
  }
  
  // Wait for split event
  const handleSplit = () => {
    console.log('Split-lines ready');
    splitLinesElement.removeEventListener('split-lines:split', handleSplit);
    callback();
  };
  
  splitLinesElement.addEventListener('split-lines:split', handleSplit);
  
  // Fallback timeout
  setTimeout(() => {
    console.log('Split-lines timeout, proceeding anyway');
    splitLinesElement.removeEventListener('split-lines:split', handleSplit);
    callback();
  }, 1000); // Reduced timeout
}